var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCircusTent(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "circus-tent 3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1320"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1322"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3746_35107",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 22,
    height: 22
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clipPath1328"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1326",
    d: "M1 0.999998H23V23H1V0.999998Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3746_35107)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1324"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1330"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1332",
    d: "M1.42969 7.73535H22.5703L22.1406 11.1729H1.85938L1.42969 7.73535Z",
    stroke: "#202842",
    strokeWidth: 0.8,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1334"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1336",
    d: "M3.16211 7.72974C5.31583 6.74476 10.1176 3.29523 12.0016 1.42957C13.8856 3.29532 18.6877 6.74502 20.8412 7.72974",
    stroke: "#202842",
    strokeWidth: 0.8,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1338"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1340",
    d: "M3.14844 11.2298C3.14844 14.1555 2.63281 19.259 1.85938 22.5133",
    stroke: "#202842",
    strokeWidth: 0.8,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1342"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1344",
    d: "M20.8516 11.2298C20.8516 14.1555 21.3672 19.259 22.1406 22.5133",
    stroke: "#202842",
    strokeWidth: 0.8,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1346"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1348",
    d: "M1.42969 22.5703H22.5703",
    stroke: "#202842",
    strokeWidth: 0.8,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1350"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1352",
    d: "M8.07227 7.70374C9.02523 6.73599 11.1622 3.3116 11.9996 1.46115C12.8371 3.3116 14.9741 6.73599 15.927 7.70374",
    stroke: "#202842",
    strokeWidth: 0.8,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1354"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1356",
    d: "M8.07261 11.2298C8.07261 14.1555 7.61659 19.259 7.27344 22.5133",
    stroke: "#202842",
    strokeWidth: 0.8,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1358"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1360",
    d: "M15.9277 11.2298C15.9277 14.1555 16.3837 19.259 16.7269 22.5133",
    stroke: "#202842",
    strokeWidth: 0.8,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1362"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1364",
    d: "M9.85156 22.3555V17.8437C9.85156 16.6621 10.8184 15.6953 12 15.6953C13.1816 15.6953 14.1484 16.6621 14.1484 17.8437V22.3555",
    stroke: "#202842",
    strokeWidth: 0.8,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircusTent);
export default __webpack_public_path__ + "static/media/circus-tent.c26716e5253c8ad0060a7402a277f6f7.svg";
export { ForwardRef as ReactComponent };